<template>
  <div class="founding-story-container">
    <img class="photo" src="../assets/about_photo.png" alt="about photo" />
    <h4>創辦人故事</h4>
    <p>
      高僑自民國81年成立，起初以經營心算、安親班為主，直到民國92年完全轉型為國中、小文理補習班。
      民國87年創辦人陳淑勤的大女兒參加國小資優班鑑定，初試考科是國語、數學、智力測驗三科，便開始研究國語考科考試內容。第二年，創辦人弟弟的小孩參加，初試成績是當時台中國小200位考生中最高分，後來竟然複試的口試關卡沒有通過，便又開始研究複試的內容，之後一路順遂，家中老二以及弟弟的小孩共三位進入國小資優班就讀，甚至這五個孩子在國中時都就讀資優班。在民國92年、93年連續兩年，高僑在台中市立忠孝國小資優班30個名額中考取23名，以及台中市公立國中資優班共90個名額裡，奪下60人上榜的佳績。
      民國90年後，私立中學漸漸興起，尤其95年起國小、國中陸續改制為分散式資優班，更讓家長們加速將小孩送入私立中學就讀。據統計108學年度約有22%的小六畢業生就讀私中。
      基於過去資優文理的基礎，在每年的私中考試中，我們的學生考上的比例高於同業很多，且經常囊括私中各校前十名榜單。學生來自中彰投地區，家長希望我們也能到其他地區設立分校，考量人力問題，自103年起我們開始以「加盟方式」拓點，目前已有3家直營校共5個服務據點，及多間加盟校服務大台中地區的家長。
    </p>
    <h4>經營理念</h4>
    <p>
      少子化的情況下，家長對於孩子的升學規劃更積極，有目標卻沒有經驗、沒有方法。只要您把孩子送到高僑，我們將和家長們一起努力，盡全力幫助孩子成就夢想。
    </p>
    <div class="table">
      <div class="row">
        <div class="column head">教學特色</div>
        <div class="column">
          高僑使用全自編教材（英文科配合英文雜誌），所有的教材由高僑教師同仁編撰，並定期校對修改，配合編輯部編排教材內容，使教材更加優良且更加精準。
        </div>
      </div>
      <div class="row">
        <div class="column head">小班制教學</div>
        <div class="column">
          小班制教學是高僑一貫的堅持，對班級人數嚴格的控制，使每一位學生都能在更好的環境上課，享受更高的教學品質。
          每班都會派一位班導師，負責控制班級秩序、與家長間的聯絡、批改及訂正作業，成為老師與家長間不可或缺的橋樑。
        </div>
      </div>
      <div class="row">
        <div class="column head">依程度分班</div>
        <div class="column">
          孩子在愈適合自己程度的班級，學習的成效會更好！
          高僑細分多種不同程度的課程，詳細規劃程度的分級，讓每個學生在最適合的班級上課，發揮最大的學習效率！
        </div>
      </div>
      <div class="row">
        <div class="column head">豐富教學經驗</div>
        <div class="column">
          高僑經營考資優、考私中課程已有20年以上經驗，擁有全台中最多的據點，以及最好的榜單。無論你是成績頂尖的學生，想考進私中的百名榜，或是你的目標明確，想就讀私立中學，高僑會是你最好的選擇。
        </div>
      </div>
    </div>
    <h4>高僑大事記</h4>
    <AboutUsTimeLine class="timeline" />
    <iframe
      class="video"
      src="https://www.youtube.com/embed/-gaKJn43uCI"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import AboutUsTimeLine from "@/components/AboutUsTimeLine.vue";

export default {
  components: {
    AboutUsTimeLine
  }
};
</script>

<style lang="scss" scoped>
.video {
  width: 100%;
  margin: 50px 0 0;
  height: 250px;
}
.founding-story-container {
  margin: auto;
  max-width: 848px;

  .photo {
    width: 656px;
    max-width: 100%;
    margin: auto;
    display: block;
  }

  h4 {
    margin: 30px 0 0;
    color: #1c2e53;
    font-weight: bold;
    font-size: 20px;
  }

  p {
    color: #666666;
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 2px;
    line-height: 1.5;
  }

  .table {
    margin-top: 15px;
    border-radius: 10px;
    overflow: hidden;
    .row {
      display: flex;
      flex-direction: row;
      margin-bottom: 1px;
      .column {
        flex: 1;
        background-color: #bec19630;
        padding: 17px;
        color: #565656;
        font-weight: bold;
        font-size: 16px;
        letter-spacing: 2px;
        line-height: 1.5;
        &.head {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: none;
          width: 120px;
          background-color: #c4cb7a;
          color: white;
        }
      }
    }
  }

  .timeline {
    margin: 25px -50px;
  }
}

@media (max-width: 1023px) {
  h4 {
    text-align: center;
  }

  p {
    margin: auto 10px;
  }

  .table {
    margin: auto 10px;
    .row {
      flex-direction: column !important;
      margin-bottom: 8px !important;
      border-radius: 9px !important;
      overflow: hidden !important;

      .column {
        padding: 7px 12px !important;

        &.head {
          width: 100% !important;
          text-align: center !important;
          padding: 7px 0 !important;
        }
      }
    }
  }

  .timeline {
    margin: 15px 0 !important;
  }
}
@media (min-width: 500px) {
  .video {
    height: 350px;
  }
}
@media (min-width: 680px) {
  .video {
    height: 400px;
  }
}
@media (min-width: 1023px) {
  .video {
    width: 116%;
    margin: 50px -8% 0;
    height: 500px;
  }
}
</style>
